import { Selectbutton } from '@/shared/ui/Selectbutton'
import { useCommonCodes } from '@/shared/lib/codes'
import type { OrgNewDraft } from '@/public/features/org/types'
import { StepHeadLarge } from '@/public/features/org/ui/orgNew/parts'

export function StepCardResource({ draft }: { draft: OrgNewDraft }) {
  const resources = useCommonCodes('resource')

  return (
    <section className="flex flex-col gap-8">
      <StepHeadLarge
        title="제공 가능한 서비스는 무엇인가요?"
        desc="제공 가능한 서비스의 종류를 선택해주세요."
      />
      <div className="flex flex-col gap-3 [&>.ui-selectbutton]:w-full [&>.ui-selectbutton]:min-w-[150px]">
        {(resources.data ?? []).map((r) => (
          <Selectbutton
            key={r.code}
            size="lg"
            label={r.label}
            isOn={draft.cardResourceCodes.includes(r.code)}
            onSelect={() => draft.toggleCardResource(r.code)}
          />
        ))}
      </div>
    </section>
  )
}
